import script from "./customFieldsSidebarComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./customFieldsSidebarComponent.vue?vue&type=script&setup=true&lang=js"

import "./customFieldsSidebarComponent.vue?vue&type=style&index=0&id=60305f0e&lang=css"

const __exports__ = script;

export default __exports__